import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import { useTranslation } from '../../hooks/useTranslation';
import LanguageSwitcher from '../../components/ui/LanguageSwitcher';

const MIHeader = ({ subtitle }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const resolvedSubtitle = subtitle || t('mandiFactory.govtQuotaTracker', 'Govt Sugar Quota Tracker');
  return (
    <header className="sticky top-0 z-50 w-full bg-[var(--bg-secondary)]/95 backdrop-blur-md border-b border-[var(--border-light)]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
            <div className="w-10 h-10 rounded-xl overflow-hidden bg-[var(--bg-surface)] flex-shrink-0 border border-[var(--border-light)]">
              <img src="/assets/images/ChatGPT_Image_Dec_1_2025_08_15_51_PM-1764613791088.png" alt="SugarHathi logo" className="w-full h-full object-contain" />
            </div>
            <div>
              <span className="text-lg font-black tracking-tight text-[var(--text-primary)]">SugarHathi</span>
              <span className="hidden sm:block text-[10px] leading-none mt-0.5 text-[var(--text-muted)]">{resolvedSubtitle}</span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <LanguageSwitcher tone="dark" />
            <button onClick={() => navigate('/market-intelligence/search')} className="flex items-center gap-1.5 text-sm font-medium text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors">
              <Icon name="Search" size={16} /> {t('common.search', 'Search')}
            </button>
            <button onClick={() => navigate('/')} className="text-sm font-medium text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors">
              {t('header.home', 'Home')}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default MIHeader;

